// extracted by mini-css-extract-plugin
module.exports = {"root":"SEOBreadcrumbs_root__3NUUI","breadcrumbs":"SEOBreadcrumbs_breadcrumbs__3NrnX"};